import React from "react";

const DeleteList = ({ closeTray, handleDeleteList, listName }) => {
  return (
    <div
      style={{ paddingTop: "12px", gap: "12px" }}
      className="d-flex flex-column w-100"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="d-flex flex-column align-items-center"
        style={{ padding: "0px 32px" }}
      >
        <svg
          width="61"
          height="60"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.25"
            y="0.75"
            width="58.5"
            height="58.5"
            rx="29.25"
            stroke="#676A79"
            stroke-width="1.5"
          />
          <path
            d="M43.8865 20.6042V42.4501C43.8865 45.2385 41.8977 46.4116 39.469 45.0654L31.9535 40.854C31.1503 40.4117 29.8499 40.4117 29.0467 40.854L21.5313 45.0654C19.1026 46.4116 17.1138 45.2385 17.1138 42.4501V20.6042C17.1138 17.3158 19.791 14.6235 23.0611 14.6235H37.9391C41.2092 14.6235 43.8865 17.3158 43.8865 20.6042Z"
            stroke="#676A79"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Are you sure you want to delete{" "}
          <span style={{ fontWeight: "500", color: "black" }}>{listName}?</span>{" "}
          This action cannot be undone.
        </div>
      </div>
      <div
        className="d-flex flex-column w-100"
        style={{ gap: "8px", padding: "6px 0px" }}
      >
        <div
          onClick={() => handleDeleteList()}
          style={{
            height: "42px",
            borderRadius: "8px",
            backgroundColor: "#005FDA",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Delete
        </div>
        <div
          onClick={closeTray}
          style={{
            height: "42px",
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            color: "#676A79",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Cancel
        </div>
      </div>
    </div>
  );
};

export default DeleteList;
